
import { Component, Vue } from 'vue-property-decorator';
import { iChannelTotal, iTimeParams } from '@/interface/exchange-code';
import { getChannelSummary } from '@/api/exchange-code';
@Component
export default class ChannelExtension extends Vue {
  private dataValue: Date[] = [];
  totalTable: iChannelTotal[] = [];
  loading: boolean = false;
  private pickerBeginDateBefore: { disabledDate: Function } = {
    disabledDate(time: any) {
      return time.getTime() > Date.now();
    },
  };
  timeInfo: iTimeParams = {
    start: 0,
    end: 0,
  };
  dataChange(datavalue: Date[]) {
    if (!datavalue) {
      // 时间清除
      this.timeInfo.start = 0;
      this.timeInfo.end = 0;
      this.$emit('dataChange', this.timeInfo);
      this.getList();
      return;
    }
    this.timeInfo.start = Math.floor(datavalue[0].getTime() / 1000);
    this.timeInfo.end = Math.floor(datavalue[1].getTime() / 1000) + 3600 * 24 - 1;
    this.$emit('dataChange', this.timeInfo);
    this.getList();
  }
  async getList() {
    this.loading = true;
    try {
      const res = await getChannelSummary(this.timeInfo);
      if (res && res.code == 0) {
        this.totalTable = res.data;
        this.loading = false;
      }
    } catch (err) {
      this.loading = false;
      console.log(err);
    }
  }
  mounted() {
    this.getList();
  }
}
